import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import { useToggle } from '@/src/hooks/useToggle';
import { RootState } from '@/src/reducers/types';

import { LibraryFileEntryViewer } from '../../../Modal/FileViewer2/FileEntryViewerWrapper';
import RestoreFolders from '../../../Modal/RestoreFolders/RestoreFolders';
import Select from '../Actions/Select/Select';

const Filename = ({ file, provided, snapshot }) => {
  const dispatch = useDispatch();
  const files = useSelector((state: RootState) => state.files);
  const [isRestoreModalOpen, toggleIsRestoreModalOpen] = useToggle(false);
  const [isFileviewerOpen, toggleIsFileviewerOpen] = useToggle(false);

  const handleFileView = () => {
    if (file.type !== 'folder') {
      $(`#task-details`).modal('hide');
      // dispatch({ type: 'SET_DOCUMENT_SELECTED', Selected: { ...file } }); // For legacy
      dispatch({ type: 'UPDATE_FILES_SELECTED', selected: file });
      toggleIsFileviewerOpen(true);
    } else {
      dispatch({
        type: 'UPDATE_FILES_SIDEBAR_ACTIVE',
        menu: { id: 'library', label: 'Library' },
      });
      dispatch({
        type: 'UPDATE_FILES_ACTIVE_FOLDER',
        folder: { id: file.id, label: file.origin },
      });
    }
  };

  const handleView = () => {
    const inTrash = files.activeInSidebar.id === 'trash';

    if (file.type === 'folder') {
      if (inTrash) {
        dispatch({ type: 'UPDATE_FILES_SELECTED', selected: file });
        toggleIsRestoreModalOpen(true);
        return;
      }

      dispatch({
        type: 'UPDATE_FILES_ACTIVE_FOLDER',
        folder: { id: file.id, label: file.name, referrer: 'main-table' },
      });
      return;
    }

    if (file.type === 'document' || !inTrash) {
      handleFileView();
    } else {
      dispatch({ type: 'UPDATE_FILES_SELECTED', selected: file });
      toggleIsRestoreModalOpen(true);
    }
  };

  return (
    <React.Fragment>
      <div className={`listItem`}>
        <Select file={file} provided={provided} snapshot={snapshot} />
        <a onClick={handleView} className={`fileName `} data-tooltip-id={`${file.id}-file`}>
          <i className="material-icons">{file.type === 'folder' ? 'folder' : 'description'}</i>
          <span>{file.name}</span>
        </a>
        <Tooltip className="fileNameTooltip" id={`${file.id}-file`} place="bottom" effect="solid">
          {file.name}
        </Tooltip>
      </div>
      {isRestoreModalOpen && (
        <ModalPortal>
          <RestoreFolders onClose={() => toggleIsRestoreModalOpen(false)} file={file} />
        </ModalPortal>
      )}
      {isFileviewerOpen && (
        <ModalPortal>
          <LibraryFileEntryViewer onClose={() => toggleIsFileviewerOpen(false)} file={file} />
        </ModalPortal>
      )}
    </React.Fragment>
  );
};

export default Filename;
